import { makeStyles } from '@vakantiesnl/components/src/styles/themes/themewrapper';

export const useCustomStyles = makeStyles()((theme) => ({
	wrapper: {
		display: 'inline-flex',
		alignItems: 'center',
	},
	starIcon: {
		flex: 'none',
		color: theme.rating.color,
	},
}));
